<template>
  <modal :name="name" @before-open="beforeOpen" width="50%" height="50%">
    <div class="modal-create-new-group" v-if="groupTemplate">
      <div class="modal-title">
          <edit-in-place v-model="groupName" :placeholder="'Untitled group'"></edit-in-place>
          <div class="modal-actions">
            <div class="btn btn--secondary" @click="createGroup">Create group</div>
            <div class="close" @click="closeModal"></div>
          </div>
      </div>
      <div class="modal-body">
        <div class="results-values">
          <div class="value-block">
            <div class="field-name">{{$t('number_of_subjects')}}</div><div class="selection-value">{{selection.length}}</div>
          </div>
          <div class="value-block">
            <div class="field-name">Male percentage</div><div class="selection-value">{{malePercent}}%</div>
          </div>
        </div>
        <div class="results-values">
          <div class="value-block">
            <div class="field-name">{{$t('diseases')}}</div><div class="selection-value">{{selectionCohortInfo('diseases')}}</div>
          </div>
        </div>
        <div class="results-values">
          <div class="value-block">
            <div class="field-name">{{$t('treatments')}}</div><div class="selection-value">{{selectionCohortInfo('treatments')}}</div>
          </div>
        </div>
        <div class="results-values">
          <div class="value-block" v-for="field in outputFields" :key="field">
            <div class="field-name">{{ field }}</div>
            <div
              class="selection-value"
              v-if="selection && selection.length > 0"
            >
              {{ Number.parseFloat(mean(selection, field)).toFixed(2) }} ±
              {{ Number.parseFloat(std(selection, field)).toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import _ from 'underscore'
import Api from '@/api'
import EditInPlace from '@/components/commons/EditInPlace'
import { std, mean } from '@/utils/Math'
import {getGeneralCharacteristicField, getOtherSubjectFields} from '@/utils'

export default {
  name: 'ModalCreateGroup',
  props: ['name', 'project'],
  components: {EditInPlace},
  data() {
    return {
      groupName: '',
      selection: [],
      groupTemplate: null
    }
  },
  created () {
    Api.getFilterTemplate(this.project).then(resp => {
      this.groupTemplate = resp
    })
  },
  computed: {
    outputFields () {
      return this.selection[0] && (this.selection[0].scalars || []).map((d)=>d.name) || []
    },
    malePercent () {
      let men = this.selection.filter(e => getGeneralCharacteristicField(e, 'female/male ratio') || getGeneralCharacteristicField(e, 'Is Male'))
      return (men.length / this.selection.length  * 100).toFixed(1)
    }
  },

  asyncComputed: {
  },
  methods: {
    beforeOpen(event) {
      this.groupName = ''
      if(event.params && event.params.selection) {
        this.selection = event.params.selection
      }
    },
    createGroup () {
      let groupFilter = JSON.parse(JSON.stringify(this.groupTemplate))
      groupFilter.name = this.groupName || 'Untitled group'
      groupFilter.populations = []
      if (this.selection) {
        groupFilter.subjectIds = this.selection.map(el => el.subject.id)
      }
      Api.postGroup(this.project, groupFilter).then(el => {
        this.$emit('created', el)
        this.$modal.hide(this.name)
      }).catch(err => {
        console.log(err)
      })
    },
    closeModal(){
      this.$modal.hide(this.name)
    },
    mean(list, fieldName) {
      list = list.filter((c)=>c.scalars)
      let vals = list.map(c => c.scalars.find((d)=>d.name === fieldName).value)
      return mean(vals)
    },
    std(list, fieldName) {
      list = list.filter((c)=>c.scalars)
      let vals = list.map(c => c.scalars.find((d)=>d.name === fieldName).value)
      return std(vals)
    },
    selectionCohortInfo (field) {
      let conds = this.selection.map(s => getOtherSubjectFields(s, field)).flat().filter(e => e != null)
      let count = _.countBy(conds)
      return count ? Object.keys(count).map(k => k+' ('+count[k]+')').join(', ') : 'None'
    }
  }
}
</script>

<style lang="stylus">
.modal-create-new-group
  display: flex
  flex-direction: column
  height: 100%
  padding: 25px
  width: 100%
  background $athens-gray
  .modal-title
    padding-bottom: 10px
    display flex
    position relative
    align-items center
    border-bottom 1px solid $titan-white
    .edit-in-place
      input
        color: $cloud-burst
        m-font-size(18,22)
    .modal-actions
      margin-left auto
      display flex
      align-items center
      max-height 32px

    .close
      margin-left 20px
      cursor: pointer
      height: 22px
      m-icon("cross", 22)
      width: @height

  .main-row
    align-items: center
    display: flex
    margin-bottom: 20px
    position: relative
    width: 100%

    .input-container
      height: 48px
      width: 100%
      border-radius 4px
      border: 1px solid $heather
      padding 4px
    input
      background: none
      border none
      font-weight: $fw-medium
      m-font-size(30, 34)
      outline: none
      &::placeholder
        color: $spun-pearl
        // font-style: italic


  .modal-body
    .results-values
      display: flex
      flex-wrap: wrap
      border-bottom 1px solid $titan-white
      padding 20px 0px
      .value-block
        display: flex
        flex-wrap: nowrap
        align-items baseline
        margin-right 20px
      .field-name
        color: $shuttle-gray
        m-font-size(13, 15)
        text-transform: uppercase
        margin-right 5px
      .selection-value
        color: $cloud-burst
        m-font-size(13, 15)
</style>